import { connect } from "@formily/react";
import { twMerge } from "tailwind-merge";

export const Html = connect((props) => {
  return (
    <div
      className={twMerge(props.className)}
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
});
